/******************************************************************************
 * Memokid: A game to train one's memory                                      *
 * Copyright (C) 2022 Lukas Laag                                              *
 * This file is part of Memokid                                               *
 *                                                                            *
 * Memokid is free software: you can redistribute it and/or modify            *
 * it under the terms of the GNU General Public License as published by       *
 * the Free Software Foundation, either version 3 of the License, or          *
 * (at your option) any later version.                                        *
 *                                                                            *
 * Memokid is distributed in the hope that it will be useful,                 *
 * but WITHOUT ANY WARRANTY; without even the implied warranty of             *
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the              *
 * GNU General Public License for more details.                               *
 *                                                                            *
 * You should have received a copy of the GNU General Public License          *
 * along with Memokid.  If not, see <https://www.gnu.org/licenses/>.          *
 *                                                                            *
 ******************************************************************************/

import { useIntl } from 'react-intl'
import { connect } from 'react-redux'
import Button from '@mui/material/Button'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import InfoIcon from '@mui/icons-material/Info'
import SettingsIcon from '@mui/icons-material/Settings'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'
import { ensureLoaded, filterPlayers, nonDemoPlayers } from '../actions/game'
import { go, routes } from '../location'
import Title from '../components/Title'
import Summary from '../components/Summary'
import { LEVELS, log } from '../logs'

const TitleScreen = props => {
  log('TitleScreen', LEVELS.INFO, props)
  const {
    decks, players, settings: { cardCount, matchCount, deckRefid },
    dispatch
  } = props
  const intl = useIntl()

  // preload the current deck
  ensureLoaded(decks[deckRefid], dispatch)

  const gamePlayers = filterPlayers(players, nonDemoPlayers)
  return (
    <div className='title-screen'>
      <Title />
      <div className='title-start'>
        <Button
          variant='contained'
          startIcon={<PlayArrowIcon />}
          onClick={() => dispatch(go(routes.GAME))}
        >{intl.formatMessage({ id: 'title.newGameButton' })}
        </Button>
        <Summary
          players={gamePlayers}
          cardCount={cardCount * matchCount}
          matchCount={matchCount}
        />
      </div>
      <div className='title-buttons'>
        <Button
          variant='outlined'
          startIcon={<InfoIcon />}
          onClick={() => dispatch(go(routes.ABOUT))}
        >{intl.formatMessage({ id: 'title.aboutButton' })}
        </Button>
        <Button
          variant='outlined'
          startIcon={<SettingsIcon />}
          onClick={() => dispatch(go(routes.SETTINGS))}
        >{intl.formatMessage({ id: 'title.settingsButton' })}
        </Button>
        <Button
          variant='outlined'
          startIcon={<EmojiEventsIcon />}
          onClick={() => dispatch(go(routes.SCORES))}
        >{intl.formatMessage({ id: 'title.scoresButton' })}
        </Button>
      </div>
    </div>
  )
}

TitleScreen.displayName = 'TitleScreen'

const mapStateToProps = ({ decks, players, settings }) => ({ decks, players, settings })
export default connect(mapStateToProps)(TitleScreen)
